module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/shutterstock_2226128901.0ba21c3d.png";